import { EnvironmentsInterface } from '@core-utils';

export const environment: EnvironmentsInterface = {
  production: false,
  api: 'https://api-dev.mjpoints.com/api/v1/',
  name: 'DEV',
  landingUrl: 'https://dev.mj1.co',
  helpHeroAppId: 'Aa7eTXxk64',
  keycloak: {
    production: true,
    oauthServerHost: 'https://auth-dev.rewardsandpoints.com',
    oauthRealm: 'mjpoints-realm',
    oauthClientId: 'mjpoints-public-cli',
    superAdminRole: 'super_user',
    responseType: 'code',
    scope: 'openid profile email offline_access onboarded_scope',
  },
};
